// Vùng giao hàng (Nội tỉnh / Liên tỉnh / Nội miền / Liên miền): dùng CHUNG bộ
// quy tắc với server (packages/common/src/geo/route-resolver.ts) để giá báo
// lúc tạo đơn và giá server ghi sổ luôn cùng một vùng. File này chỉ thêm phần
// hiển thị (huy hiệu màu) của giao diện.
import type { ShippingRoute } from '@shoptrack/common/geo'

export {
  resolveShippingRoute,
  getRegionForProvince,
  canonicalizeProvince,
  toProvince34,
  SHIPPING_ROUTES,
  ROUTE_LABELS,
  ROUTE_RULES,
  REGION_RULES,
  type ShippingRoute,
  type VietnamRegion,
} from '@shoptrack/common/geo'

export const ROUTE_BADGES: Record<ShippingRoute, { label: string; icon: string; bgClass: string; textClass: string }> = {
  noi_tinh: { label: 'Nội tỉnh', icon: '', bgClass: 'tone-green bg-toneBg border-toneFg/25', textClass: 'text-toneFg' },
  lien_tinh: { label: 'Liên tỉnh', icon: '', bgClass: 'tone-blue bg-toneBg border-toneFg/25', textClass: 'text-toneFg' },
  noi_mien: { label: 'Nội miền', icon: '', bgClass: 'tone-violet bg-toneBg border-toneFg/25', textClass: 'text-toneFg' },
  lien_mien: { label: 'Liên miền', icon: '', bgClass: 'tone-orange bg-toneBg border-toneFg/25', textClass: 'text-toneFg' },
}
